import React from 'react';
import { AppAlert, AppAlertDescription } from 'app/javascript/components/ui/app-alert';
import { KeyRoundIcon, MailIcon } from 'lucide-react';
import AuthCard from './AuthCard';
import AuthField from './AuthField';
import AuthLink from './AuthLink';
import DeviseForm from './DeviseForm';

type Props = {
  /** Devise の resource_name（shop / billing_account_admin）。フィールド名 `shop[email]` と id `shop_email` を組み立てる */
  resourceName: string;
  sessionPath: string;
  passwordPath: string;
  emailLabel: string;
  passwordLabel: string;
  brand?: string | null;
  title: string;
  description?: string | null;
  /** フォーム下の案内文（お問い合わせ先など） */
  supportMessage?: string | null;
  footer?: string | null;
  errorMessage?: string | null;
};

/** Devise の sessions#create へ POST するログインフォーム */
const LoginForm: React.FC<Props> = ({
  resourceName,
  sessionPath,
  passwordPath,
  emailLabel,
  passwordLabel,
  brand,
  title,
  description,
  supportMessage,
  footer,
  errorMessage,
}) => (
  <AuthCard brand={brand} title={title} description={description} errorMessage={errorMessage} footer={footer}>
    <DeviseForm action={sessionPath} submitLabel="ログイン">
      <AuthField
        id={`${resourceName}_email`}
        name={`${resourceName}[email]`}
        label={emailLabel}
        type="email"
        icon={MailIcon}
        placeholder="mail@example.com"
        autoFocus
        autoComplete="email"
        required
      />
      <AuthField
        id={`${resourceName}_password`}
        name={`${resourceName}[password]`}
        label={passwordLabel}
        type="password"
        icon={KeyRoundIcon}
        placeholder="パスワードを入力"
        autoComplete="current-password"
        required
      />
    </DeviseForm>
    <AuthLink href={passwordPath}>パスワードをお忘れの方はこちら</AuthLink>
    {supportMessage && (
      <AppAlert variant="info" className="mt-5">
        <AppAlertDescription className="leading-relaxed">{supportMessage}</AppAlertDescription>
      </AppAlert>
    )}
  </AuthCard>
);

export default LoginForm;
